import { render } from "./InfoOfPatient.vue?vue&type=template&id=a298e8e6"
import script from "./InfoOfPatient.vue?vue&type=script&lang=js"
export * from "./InfoOfPatient.vue?vue&type=script&lang=js"

import "./InfoOfPatient.vue?vue&type=style&index=0&id=a298e8e6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__